import { Banner, CTA, HorizontalWordLoop } from '@/components'
import mailer from '../../assets/images/blog/morse.png'
import { Fade, JackInTheBox } from "react-awesome-reveal";
import { Helmet } from 'react-helmet-async';

export const TheMorseCode = () => {

    return <>


        <Helmet>
            <title>Morse Code Academy | The Morse Code</title>
            <meta name="title" content="Morse Code Academy | The Morse Code" />
            <meta
                name="description"
                content="Morse code is a method of encoding text characters as sequences of dots and dashes. It was developed in the 1830s and 1840s by Samuel Morse and Alfred Vail as a means of transmitting messages over long distances using the telegraph."
            />


            <meta
                property="og:description"
                content="Morse code is a method of encoding text characters as sequences of dots and dashes. It was developed in the 1830s and 1840s by Samuel Morse and Alfred Vail as a means of transmitting messages over long distances using the telegraph."
            />
            <meta property="og:image" content={mailer} />
            <meta
                property="og:title"
                content="Morse Code Academy | The Morse Code"
            />
            <meta property="og:type" content="website" />
            <meta property="og:url" content="https://morsecodeacademy.site/blog/the-morse-code" />
        </Helmet>

        <JackInTheBox triggerOnce={true} delay={1000}>
            <Banner
                subtitle={"Learn More About"}
                title={'THE <span class="stroke white">MORSE </span> CODE  '}
                image={mailer}
            // description="Create your software design blueprint with expert software design services."
            />
        </JackInTheBox>

        <div className="">
            <div className="container">
                <div className="row pt-5 align-items-center justify-content-center justify-content-lg-start ">
                    <div className="col-lg-12 mt-lg-0 mt-3">
                        <Fade triggerOnce={true}>
                            <h3 className='text-primary'>Introduction</h3>
                            <p className="text-white mt-3 ">
                                Morse code is a method of encoding text characters as sequences of dots and dashes. It was developed in the 1830s and 1840s by Samuel Morse and Alfred Vail as a means of transmitting messages over long distances using the telegraph.
                            </p>
                        </Fade>

                        <Fade triggerOnce={true}>
                            <h3 className='text-primary mt-3'>
                                How It Works
                            </h3>
                            <p className="text-white mt-3 ">
                                Each letter of the alphabet, as well as numbers and certain punctuation marks, is represented by a unique sequence of short signals (dots) and long signals (dashes). <br /> For example:
                            </p>
                            <ul>
                                <li><p>A: .-</p></li>
                                <li><p>B: -...</p></li>
                                <li><p>C: -.-.</p></li>
                                <li><p>1: .----</p></li>
                                <li><p>2: ..---</p></li>
                            </ul>
                        </Fade>


                        <Fade triggerOnce={true}>
                            <h3 className='text-primary  mt-4'>
                                Slashes
                            </h3>
                            <p className="text-white mt-3 ">
                                In Morse code, "/", "//", and "///" are not part of the original Morse code system but are used in modern interpretations and transcriptions to enhance readability or denote specific separations. Here's how they are typically employed:
                            </p>
                            <h4 className='text-primary  mt-3'>
                                Single Slash ( / ):
                            </h4>
                            <p className="text-white mt-3 ">
                                <strong>Purpose:</strong> Used as a separator between letters in written Morse code when pauses cannot be visually represented.
                            </p>
                            <h4 className='text-primary  mt-3'>
                                Double Slash ( // ):
                            </h4>
                            <p className="text-white mt-3 ">
                                <strong>Purpose:</strong> Used as a separator between words in written Morse code when pauses cannot be visually represented.
                            </p>
                            <h4 className='text-primary  mt-3'>
                                Triple Slash ( /// ):
                            </h4>
                            <p className="text-white mt-3 ">
                                <strong>Purpose:</strong> Used to indicate a paragraph break or a major division in the message
                            </p>
                        </Fade>

                    </div>
                </div>
            </div>
        </div>
        <Fade triggerOnce={true} delay={100}>
            <HorizontalWordLoop title={"THE MORSE CODE"} />
        </Fade>
        <div className="container">
            <div className="row pb-5 align-items-center justify-content-center justify-content-lg-start ">
                <Fade triggerOnce={true}>
                    <h3 className='text-primary  mt-3'>
                        Applications
                    </h3>
                    <p className="text-white mt-3 ">
                        Morse code was widely used in early telecommunication systems, particularly in maritime communication and military operations. Even today, it remains relevant in certain fields, such as aviation, where pilots and air traffic controllers use it to identify navigational aids.
                    </p>
                </Fade>

                <Fade triggerOnce={true}>
                    <h3 className='text-primary  mt-3'>
                        Significance
                    </h3>
                    <p className="text-white mt-3 ">
                        Morse code revolutionized communication in the 19th and early 20th centuries by enabling fast and reliable transmission of messages. Its simplicity and efficiency made it a cornerstone of global communication during its time.
                    </p>
                </Fade>

                <Fade triggerOnce={true}>
                    <h3 className='text-primary  mt-3'>
                        Fun Fact
                    </h3>
                    <p className="text-white mt-3 ">
                        The first message sent using Morse code was "<code>What hath God wrought</code>," transmitted by Samuel Morse on May 24, 1844, between Washington, D.C., and Baltimore, Maryland.
                    </p>
                </Fade>
            </div>
        </div>
        {/* <div className="container py-5">
            <div className="row">
                <div className="col-12">
                    <Slide delay={200} ><h4 className='text-primary  pb-2'>Things You Should Know About</h4></Slide>
                    <Slide delay={400} ><h2 className='text-primary pt-1'>Custom Software Design</h2></Slide>
                </div>

                <div className="col-12 mt-3">
                    <Fade triggerOnce={true}>
                        <Accordion
                            delay={1000}
                            title={"How much does custom software cost?"}
                            children={"<p class='text-white pb-3'>Costs vary by size and scope of the project. Click to read the different variables that can affect your project.</p>"}
                        />

                        <Accordion
                            delay={1200}
                            title={"How long will my project take?"}
                            children={"<p class='text-white pb-3'>No two projects are alike or take the same amount of time to build. The size and complexity of the project are the biggest factors in overall duration. Click to read more.</p>"}
                        />

                        <Accordion
                            delay={1400}

                            title={"I have an idea, now what?"}
                            children={"<p class='text-white pb-3'>Having a new software development idea can be exciting. Click to see our 6 Steps On How To Get Started With Your Software Idea.</p>"}
                        />

                        <Accordion
                            delay={1600}
                            title={"What can delay my custom software project?"}
                            children={"<p class='text-white pb-3'>Software projects often take longer than planned. Click for the common reasons why projects run over their initial time estimates.</p>"}
                        />

                        <Accordion
                            delay={1800}
                            title={"How do I turn a troubled project around?"}
                            children={"<p class='text-white pb-3'>There are many ways a software project can go wrong. What you do to turn the project around can make all the difference. Click to read how to get the project back on track.</p>"}
                        />
                    </Fade>
                </div>
            </div>
        </div> */}
        <CTA
            title={"Bridging <span class='stroke'>Ideas</span><br>To <span class='stroke '>Solutions</span>"}
            description={"Are you ready to start a new software development project? Work with our team of software designers and developers. It’s never too early, or too late, to bring your idea to life."} />


    </>

}
